<!-- 
	AdminNewsList
	props: User
  	role: Admin
	Called by @/views/AdminManageNews to display a loop of news items items to Admins
-->

<template>
	<div class="admin-news-list">
		<div v-if="!loading">
			<div class="text-3xl">Current News Items</div>
			<div v-for="item in news" :key="item.id" class="news-item">
				<div class="text-right -mb-6">
					<span v-if='item.publishDate > today' class='mr-4 text-red-400'>
						UNRELEASED
					</span>
					<span v-if='item.removalDate !== "" && item.removalDate <= today' class='mr-4 text-red-400'>
						REMOVED
					</span>
					<router-link :to="{ name: 'News_ID', params: { News_Id: item.id } }">
						<i class="fas fa-edit"></i>
					</router-link>
				</div>
				<div class="item-label">[TITLE]</div>
				<div class="text-2xl">
					{{ item.title }}
				</div>
				<div class="item-label">[Content]</div>
				<div v-html="item.content"></div>
				<div v-if="item.hyperlink">
					<div class="item-label">[HYPERLINK TEXT]</div>
					<div>{{ item.hyperlinkText }}</div>
					<div class="item-label">[HYPERLINK]</div>
					<div>{{ item.hyperlink }}</div>
				</div>
				<div class="item-label">[PUBLISH DATE]</div>
				<div>{{ item.publishDate }}</div>
				<div class="item-label">[REMOVAL DATE]</div>
				<div>
					<span v-if="item.removalDate">{{ item.removalDate }}</span
					><span v-else>N/A</span>
				</div>
				<div class="item-label">[CREATION DATE]</div>
				<div>{{ item.createdAt }}</div>
				<div class="item-label">[AUTHOR]</div>
				<div>{{ item.author }}</div>
				<div v-if='item.editor'>
					<div class="item-label">[EDITOR]</div>
					<div>{{ item.editor }}</div>
				</div>
				<div class="text-right text-red-400 cursor-pointer">
					<i class="fas fa-trash-alt" @click="deleteItem(item.id)"></i>
				</div>
			</div>
		</div>
		<div v-else>
			<Loading />
		</div>
	</div>
</template>
<script>
	import firebase from "firebase";

	import Loading from "@/components/Loading";

	export default {
		name: "AdminNewsList",
		props: ["user"],
		components: {
			Loading,
		},
		data() {
			return {
				news: [],
				error: null,
				loading: true,
				today: ""
			};
		},
		created() {
			// set todays date in this.today
			const fullDate = new Date();

			const year = fullDate.getUTCFullYear();
			const month = fullDate.getUTCMonth() + 1;
			const day = fullDate.getUTCDate();

			// if day is single digit prepend zero before day
			let zero = "";
			if (day.toString().length === 1) {
				zero = 0;
			}

			const today = year + "-" + month + "-" + zero + day;

			this.today = today;

			const db = firebase.firestore().collection("news");
			try {
				// load news items from firestore
				db.orderBy("publishDate", "desc")
					.get()
					.then((querySnapshot) => {
						querySnapshot.forEach((doc) => {
							const timestamp = doc.data().createdAt;

							const readibleDate = timestamp.toDate();

							const newsData = {
								title: doc.data().title,
								content: doc.data().content,
								hyperlink: doc.data().hyperlink,
								hyperlinkText: doc.data().hyperlinkText,
								publishDate: doc.data().publishDate,
								removalDate: doc.data().removalDate,
								createdAt: readibleDate,
								author: doc.data().author,
								editor: doc.data().editor,
								id: doc.id,
							};

							this.news.push(newsData);

							this.loading = false;
						});
					});
			} catch (err) {
				console.log(err);
			}
		},
		methods: {
			deleteItem(id) {
				// delete individual news item from firestore upon user action
				if (
					confirm(
						"Are you sure you want to delete this news item?\nThis action cannot be undone"
					)
				) {
					const db = firebase.firestore().collection("news");

					db.doc(id)
						.delete()
						.then(() => {
							alert("News item has been successfully deleted.");
							return (window.location.href = "/admin-news");
						});
				}
			},
		},
	};
</script>
<style scoped>
	.admin-news-list .news-item {
		border: 1px solid #555555;
		padding: 12.5px;
		margin: 20px;
	}

	.admin-news-list .item-label {
		font-size: 0.8rem;
		margin: 5px;
		text-transform: uppercase;
	}
</style>
